module.exports = __webpack_public_path__ + "bq.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bq.svg
// module id = 461
// module chunks = 0